export const NONE = 'none';
export const LIGHT = 'light';
export const MEDIUM = 'medium';
export const HEAVY = 'heavy';
export const BLUR_QUALITY = 20;
